export default __webpack_public_path__ + "static/media/ladyfingers.a2883c5c.jpg";